import { PaymentService } from "../payment/payment-service";

export function initCourseCheckoutPage(paymentService: PaymentService): void {
    // Wire invoice button -> payment service method
    const invoiceBtn = document.getElementById("invoiceButton") as HTMLElement | null;
    if (invoiceBtn) {
        invoiceBtn.setAttribute("type", "button"); // hard guarantee
        invoiceBtn.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();

            if (!paymentService || typeof paymentService.submitCourseInvoiceFromButton !== "function") {
                console.error("[course-checkout] paymentService missing submitCourseInvoiceFromButton");
                return;
            }

            paymentService.submitCourseInvoiceFromButton(invoiceBtn);
        });
    }

    const poInput = document.getElementById("PoNumber") as HTMLInputElement | null;
    const poError = document.getElementById("PoNumberError") as HTMLElement | null;

    if (poInput) {
        poInput.addEventListener("input", () => {
            if (poInput.value.trim().length) {
                poInput.classList.remove("input-validation-error");
                if (poError) {
                    poError.textContent = "";
                    poError.classList.add("d-none");
                }
            }
        });
    }

    // Wire up course discount code button
    const discountBtn = document.getElementById("applyCourseDiscountBtn") as HTMLButtonElement | null;
    if (discountBtn) {
        discountBtn.addEventListener("click", applyCourseDiscount);
    }

    const discountInput = document.getElementById("courseDiscountInput") as HTMLInputElement | null;
    if (discountInput) {
        discountInput.addEventListener("keydown", (e) => {
            if (e.key === "Enter") {
                e.preventDefault();
                applyCourseDiscount();
            }
        });
    }

    // Wire up remove course discount button
    const removeDiscountBtn = document.getElementById("removeCourseDiscountBtn") as HTMLButtonElement | null;
    if (removeDiscountBtn) {
        removeDiscountBtn.addEventListener("click", removeCourseDiscount);
    }
}

async function applyCourseDiscount(): Promise<void> {
    const input = document.getElementById("courseDiscountInput") as HTMLInputElement | null;
    const msg = document.getElementById("courseDiscountMessage") as HTMLElement | null;
    const container = document.querySelector<HTMLElement>(".voucher-code-form[data-course-id]");

    if (!input || !container) return;

    const code = input.value.trim();
    if (!code) return;

    const courseId = container.dataset.courseId;
    if (!courseId) return;

    if (msg) {
        msg.style.display = "none";
        msg.innerHTML = "";
    }

    try {
        const response = await fetch("/umbraco/surface/CourseBookingSurface/ApplyCourseDiscount", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ code, courseId }),
        });

        const result = await response.json();

        if (msg) {
            msg.innerHTML = `<span class="${result.success ? "text-success" : "text-danger"}">${result.message}</span>`;
            msg.style.display = "block";
        }

        if (result.success) {
            window.location.reload();
        }
    } catch {
        if (msg) {
            msg.innerHTML = `<span class="text-danger">Something went wrong. Please try again.</span>`;
            msg.style.display = "block";
        }
    }
}

async function removeCourseDiscount(): Promise<void> {
    const container = document.querySelector<HTMLElement>(".voucher-code-form[data-course-id]");
    if (!container) return;

    const courseId = container.dataset.courseId;
    if (!courseId) return;

    try {
        const response = await fetch("/umbraco/surface/CourseBookingSurface/RemoveCourseDiscount", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ courseId }),
        });

        const result = await response.json();

        if (result.success) {
            window.location.reload();
        }
    } catch {
        console.error("Failed to remove course discount");
    }
}

